import InfoTransferOrganizationModal from './InfoTransferOrganizationModal';

export default InfoTransferOrganizationModal;
